import logo from './coty-login-logo.jpg'
import checkcircle from './checkcircle.svg'

const assets = { logo, checkcircle }

export default assets

